export enum StatusCommande {     
     EnAttenteValidation=1,
     Validee=2,
     EnPreparation=3,
     EnLivraison=4,
     Debarasse=5,     
     Annulee=6
}
